import React, { useState, useEffect } from 'react';
import cl from './Comments.module.css'
import { useLoader } from './../../../hooks/useLoader';
import Loader from '../Loader/Loader'
import UserService from '../../../API/UserService';
import { FOLDER_PROFILE } from '../../../API/API'
import ava from '../HeaderUser/img/avatar.png'
import { useNavigate } from 'react-router-dom';

const CommentsList = ({ commentsList }) => {
const navigate = useNavigate();
    const [comments, setComments] = useState([]); // здесь храним плюсы1
    const [fetchData, isLoading, loadingError] = useLoader(async () => {
        for (let item of commentsList) {
            let userSerialise = await UserService.getUserForIdSerialise(item.idUser)   
            const new_comment = {id:item.idUser, key: item.id, firstName: userSerialise.data.firstName, photo: userSerialise.data.photo, timeComent: item.timeComent, comment: item.textComent,level:userSerialise.data.level }
            setComments(comments => [...comments, new_comment])
        }
    })
    

    useEffect(() => {
        fetchData()
    }, [])

    function hill_data(data) {
        let options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            timezone: 'UTC',
            hour: 'numeric',
            minute: 'numeric',
        };
        return new Date(Math.round(data) * 1000).toLocaleString("ru", options)
    }

    return (
        <div className={cl.wrapCommentsFlex}>
            {
                isLoading
                    ? <Loader />
                    : comments
                        ? comments.reverse().map(item =>
                            <div className={cl.wrap_comments_center_new_comment}>
                                <div className={cl.avatarWrapper} style={{ position: 'relative', display: 'inline-block' }}>
                                    <img onClick={() => navigate(`/profile/${item.id}`)} style={{cursor:'pointer', position: 'relative', zIndex: 2, borderRadius: 100 }} src={item.photo ? FOLDER_PROFILE + item.photo : ava} alt="" />
                                    {item && item.level > 0 && (
                                        <img
                                            src={`/rama/${item.level}_rama.png`}
                                            alt={`Рамка уровня ${item.level}`}
                                            className={cl.avatarFrame}
                                            style={{
                                                position: 'absolute',
                                                top: -2,
                                                left: -2,
                                                width: '40px',
                                                height: '40px',
                                                zIndex: 3,
                                                pointerEvents: 'none'
                                            }}
                                        />
                                    )}
                                </div>
                                <div className={cl.dataTextIntoComments}>
                                    <p>{item.firstName}
                                        <span>{hill_data(item.timeComent)}</span>
                                    </p>
                                    <div className={cl.comment_once}>{item.comment}</div>
                                </div>
                            </div>
                        )
                        : <p>Нет комментариев</p>
            }
            {loadingError &&
                <p>Ошибка загрузки</p>
            }
        </div>
    )
};
// 1
export default CommentsList;
